import { SpanText, Text } from "../../../../design";
import React from "react";
import InvoiceDetailsItem from "./invoicedetailsitems";
import getformatteddate from "../../../../utils/getformatteddate";
import Logo from "../../../../assets/imgs/swirepay-logo.svg";

type Props = {
  invoice: Object,
  account: Object
}

const InvoiceDetails = (props: Props) => {
  const { invoice, account } = props;

  const addressConvertToString = address => {
    return address && `${address.street}\n\n, ${address.city}, ${address.state} - ${address.postalCode}`;
  };

  const invoiceStatusStyle = {
    PARTIALLY_PAID: {
      color: "#464696",
      bg: "#ECECFF",
      label: "PARTIALLY_PAID"
    },
    PAID: {
      color: "#464696",
      bg: "#ECECFF",
      label: "PAID"
    },
    PARTIALLY_REFUNDED: {
      color: "#898989",
      bg: "#E2E2E2",
      label: "PARTIALLY_REFUNDED"
    },
    REFUNDED: {
      color: "#898989",
      bg: "#E2E2E2",
      label: "REFUNDED"
    },
    EXPIRED: {
      color: "#898989",
      bg: "#E2E2E2",
      label: "EXPIRED"
    },
    CANCELLED: {
      color: "#898989",
      bg: "#E2E2E2",
      label: "CANCELLED"
    }
  };

  return (
    <>
      <div className="row no-gutters mb-4">
        <div className="col text-left">
          <img height="50rem" src={account && account.largeLogo} alt="" />
        </div>
        <div className="col text-right">
          <div>
            <span className="text-muted"><span className="pr-2">Powered by</span><span><img src={Logo} height="45rem" style={{ marginBottom: "-10px" }} alt="" /></span></span>
          </div>
        </div>
      </div>
      <div className="row mb-4 d-flex align-items-center">
        <div className="col-md text-left">
          <Text color="#273142" fontSize="18px" >INVOICE No.
            <SpanText className="px-2" color="#000000" fontSize="18px" fontWeight="600">{invoice && invoice.invoiceNumber}</SpanText></Text>
        </div>
        <div className="col-md-2 text-left mt-2 mt-md-0">
          {
            invoice && ["PAID", "CANCELLED", "REFUNDED", "PARTIALLY_REFUNDED", "PARTIALLY_PAID", "EXPIRED"].includes(invoice.status)
            && <SpanText className="px-2 py-1 rounded" color={invoiceStatusStyle[invoice.status].color}
              fontWeight="900" backgroundColor={invoiceStatusStyle[invoice.status].bg}>{invoiceStatusStyle[invoice.status].label}</SpanText>
          }
        </div>
        <div className="col-md text-left mt-3 mt-md-0 px-1">
          {invoice && "PAID" === invoice.status
            && <SpanText className="px-2" color="#000000" fontSize="14px" fontWeight="600">
              {invoice.paymentDate && `Payment Date: ${getformatteddate(invoice.paymentDate, account && account.timezone)}`}
            </SpanText>}
        </div>
      </div>
      <div className="row">
        <InvoiceDetailsItem
          header={"Description"}
          body={invoice && invoice.description}
        />
        <div className="col-12 col-md-2" />
        <InvoiceDetailsItem
          header={"Payment Due Date"}
          body={invoice && invoice.paymentDueDate && getformatteddate(invoice.paymentDueDate, account && account.timezone)}
        />
      </div>
      <div className="row">
        <InvoiceDetailsItem
          header={"Bill to"}
          body={invoice && invoice.customer && invoice.customer.name}
        />
        <div className="col-12 col-md-2" />
        <InvoiceDetailsItem
          header={"Issue Date"}
          body={invoice && invoice.paymentDueDate && getformatteddate(invoice.issueDate, account && account.timezone)}
        />
      </div>
      <div className="row">
        <InvoiceDetailsItem
          header={"Billing Address"}
          body={addressConvertToString(invoice && invoice.billingAddress)}
        />
        <div className="col-12 col-md-2" />
        <InvoiceDetailsItem
          header={"Shipping Address"}
          body={addressConvertToString(invoice && invoice.shippingAddress)}
        />
      </div>
      <div className="row">
        <InvoiceDetailsItem
          header={"Expiry Date"}
          body={invoice?.expiryDate ? getformatteddate(invoice.expiryDate, account && account.timezone) : "N.A."}
        />
        <div className="col-12 col-md-2" />
        <InvoiceDetailsItem
          header={"Service Date"}
          body={invoice?.serviceDate ? getformatteddate(invoice.serviceDate, account && account.timezone) : "N.A."}
        />
      </div>
    </>
  )
};

export default InvoiceDetails
